module.exports = __webpack_public_path__ + "static/img/peixun.56a12332.png";